/*eslint max-lines-per-function: ["error", 170]*/
import React from 'react';
import { Form, Card, Button } from 'react-bootstrap';

import FormRow from '../../../app/components/FormRow';
import { FormSelect } from '../../../app/components/FormSelect';
import { CreateUpdateExamWithTestsDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import momencik from '../../../common/momencik';
import { ExaminationType } from '../../../common/spdCore/validation/schemas';

interface Props {
  prevStep?: () => void;
  nextStep?: () => void;
  handleFormData?: (
    input: string,
  ) => (e: string | boolean | Date | undefined | null) => void;
  employmentCandidate?: boolean;
  employeePeriod?: string;
  employerName?: string;
  employerAddress?: string;
  employmentPosition?: string;
  referralDate?: Date;
  type?: ExaminationType;
  propertyChange?: (obj: Partial<CreateUpdateExamWithTestsDto>) => void;
}

export const AddEmployer: React.FC<Props> = ({
  prevStep,
  nextStep,
  handleFormData,
  employmentCandidate,
  employeePeriod,
  employerName,
  employerAddress,
  employmentPosition,
  referralDate,
  type,
  propertyChange,
}) => {
  const handleOnNext = () => {
    if (nextStep) {
      nextStep();
    }
  };

  const handleOnPrev = () => {
    if (prevStep) {
      prevStep();
    }
  };

  const propertyChangeWithHandleFormData = (
    field: string,
    checked: boolean | string | Date | undefined | null,
  ) => {
    if (handleFormData) {
      handleFormData(field)(checked);
    }
    if (propertyChange) {
      propertyChange({ [field]: checked });
    }
  };

  return (
    <>
      <Card>
        <Card.Body>
          <Card.Subtitle className="mb-4">Pracodawca</Card.Subtitle>
          <Form className="d-grid gap-3">
            <FormRow controlId="employment_candidate" label="Kandydat">
              <Form.Check
                type="checkbox"
                checked={employmentCandidate ? true : false}
                onChange={e =>
                  propertyChangeWithHandleFormData(
                    'employmentCandidate',
                    e.target.checked,
                  )
                }
              />
            </FormRow>
            {employmentCandidate !== true && (
              <FormRow controlId="employeePeriod" label="Okres zatrudnienia">
                <Form.Control
                  as="textarea"
                  rows={2}
                  value={employeePeriod || ''}
                  onChange={e =>
                    propertyChangeWithHandleFormData(
                      'employeePeriod',
                      e.target.value,
                    )
                  }
                />
              </FormRow>
            )}
            <FormRow controlId="employerName" label="Nazwa pracodawcy">
              <Form.Control
                as="textarea"
                rows={3}
                value={employerName || ''}
                onChange={e =>
                  propertyChangeWithHandleFormData(
                    'employerName',
                    e.target.value,
                  )
                }
              />
            </FormRow>
            <FormRow controlId="employerAddress" label="Adres pracodawcy">
              <Form.Control
                as="textarea"
                rows={3}
                value={employerAddress || ''}
                onChange={e =>
                  propertyChangeWithHandleFormData(
                    'employerAddress',
                    e.target.value,
                  )
                }
              />
            </FormRow>
            <FormRow controlId="employmentPosition" label="Stanowisko">
              <Form.Control
                as="textarea"
                rows={3}
                value={employmentPosition || ''}
                onChange={e =>
                  propertyChangeWithHandleFormData(
                    'employmentPosition',
                    e.target.value,
                  )
                }
              />
            </FormRow>
            <FormRow controlId="referralDate" label="Data skierowania">
              <Form.Control
                type="date"
                name="referralDate"
                placeholder="DateRange"
                value={referralDate ? momencik(referralDate, 'YYYY-MM-DD') : ''}
                onChange={e =>
                  propertyChangeWithHandleFormData(
                    'referralDate',
                    e.target.value ? new Date(e.target.value) : null,
                  )
                }
              />
            </FormRow>
            <FormRow controlId="type" label="Rodzaj badania lekarskiego">
              <FormSelect
                value={type}
                options={[
                  { value: 'Initial', label: 'wstępne' },
                  { value: 'Periodic', label: 'okresowe' },
                  { value: 'Control', label: 'kontrolne' },
                  { value: 'PeriodicControl', label: 'okresowo-kontrolne' },
                ]}
                onChange={value =>
                  propertyChangeWithHandleFormData(
                    'type',
                    !value ? undefined : value,
                  )
                }
              />
            </FormRow>

            {prevStep && nextStep && (
              <div className="d-flex justify-content-end m-3">
                <Button
                  variant="outline-secondary"
                  className="ms-1"
                  onClick={handleOnPrev}
                >
                  Wstecz
                </Button>

                <Button
                  variant="outline-primary"
                  className="ms-1"
                  onClick={handleOnNext}
                >
                  Dalej
                </Button>
              </div>
            )}
          </Form>
        </Card.Body>
      </Card>
    </>
  );
};
